export default __webpack_public_path__ + "static/media/build-wealth.4d21f310.svg";